module.exports = __webpack_public_path__ + "static/media/ipad.5e695143.png";